/**
 * Anzeigenamen der Ausgabe-Kategorien.
 *
 * <p>Die Werte kommen ASCII-portabel vom Server (`Heizoel`, `Muell`) — eine Transportform, kein
 * Produkttext. Die Übersetzung lag bis Sprint 55 zweimal in der Akte; die Auswertung hätte eine
 * dritte Kopie gebraucht. Jetzt eine Stelle für alle drei.</p>
 */
const CATEGORY_LABELS: Readonly<Record<string, string>> = {
  Strom: 'Strom',
  Gas: 'Gas',
  Wasser: 'Wasser',
  Heizoel: 'Heizöl',
  Internet: 'Internet',
  Muell: 'Müll',
  Versicherung: 'Versicherung',
  Reparatur: 'Reparatur',
  Reinigung: 'Reinigung',
  Verwaltung: 'Verwaltung',
  GrundsteuerKommunal: 'Grundsteuer/Kommunal',
  Zinsen: 'Zinsen',
  Sonstiges: 'Sonstiges',
};

/** Unbekannte Kategorien behalten ihren Wert — er ist immer noch mehr als ein Gedankenstrich. */
export function expenseCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category;
}

export { CATEGORY_LABELS as EXPENSE_CATEGORY_LABELS };
